// base
import React, { Component } from 'react';

// components
import { Button } from 'react-bootstrap';
import { ContractAbiViewData } from '../../components';

import "./ContractAbiView.scss";

class ContractAbiView extends Component {

  constructor(props) {
    super(props);
    this.state = this.initState(props.abiViewData);
  }

  initState = (abiViewData) => {
    let status = [];
    let refs = [];

    abiViewData.forEach((data, i) => {
      status[i] = false;
      refs[i] = React.createRef();
    });

    return { status, refs, isAllOpen: false };
  }

  toggleAbiView = (index, open) => {
    let { status, isAllOpen } = this.state;
    status[index] = open === undefined ? !status[index] : open;
    isAllOpen = status.every((status) => {
      return status;
    });
    this.setState({ status, isAllOpen });
  };

  toggleAllAbiView = (open) => {
    let { isAllOpen, status } = this.state;
    isAllOpen = open === undefined ? !isAllOpen : open;
    status = status.map(() => isAllOpen);
    this.setState({ isAllOpen, status });
  };

  resetAbiView = () => {
    const { refs } = this.state;
    this.toggleAllAbiView(false);
    refs.forEach(ref => {
      ref.current.reset();
    });
  };

  render() {
    const { address, creator, abiViewData } = this.props;
    const { isAllOpen, refs, status } = this.state;

    return (
      <div className="abi-view">
        <div className="contract-abi-header">
          <div className="contract-abi-title">Read Contract Information</div>
          <div className="contract-abi-btns">
            <Button variant="link" onClick={() => this.toggleAllAbiView()}>
              { isAllOpen ? '[Collapse All]' : '[Expand All]'}
            </Button>
            <Button variant="link" onClick={this.resetAbiView}>
              [Reset]
            </Button>
          </div>
        </div>
        {
          abiViewData.map((data, i) => {
            return <ContractAbiViewData key={i} index={i}
                                        abiViewData={data}
                                        ref={refs[i]}
                                        address={address}
                                        creator={creator}
                                        activate={status[i]}
                                        onClick={this.toggleAbiView} />
          })
        }
      </div>
    )
  }
}

export default ContractAbiView;
